// InfiniteScroll looks this up once and falls back to the window when it finds
// nothing, so the element carrying it has to be the one that scrolls. The list
// view's sticky header resolves against it too, which is why this is not a
// constant inside the section: the table must not import the section.
export const ALBUMS_SCROLL_CONTAINER_ID = "albumsScrollableDiv"

export const albumsScrollContainer = (): HTMLElement =>
  document.getElementById(ALBUMS_SCROLL_CONTAINER_ID) ?? window.document.body
